import { createContext } from '../../utils/createContext.js';
export const [PopoverProvider, usePopoverContext] = createContext('PopoverContext');
export const [PopoverOptionsProvider, usePopoverOptionsContext] = createContext('PopoverOptionsContext');
